export default __webpack_public_path__ + "static/media/estimated-hours.d9367c1e.svg";